import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';

import {
  getImageCarouselSetting,
  getImageCollapseOpenStatus,
  getImageCollapseValidationMsgDisplay,
  onImageCollapseOpen,
  onImageErrorChange,
} from 'src/constrains/ResponsiveLayerEditor/slice';
//import { get } from 'lodash';

import { EImageEditCollapse } from 'src/constrains/ResponsiveLayerEditor/tools';
import { validateCarouselSetting } from 'src/constrains/ResponsiveLayerEditor/ImagePosterEdit/tool';
import CarouselSetting from './CarouselSetting';

export default ErrorProcessingHOC(CarouselSetting, {
  getCollapseOpenStatus: getImageCollapseOpenStatus,
  onCollapseOpen: onImageCollapseOpen,
  id: EImageEditCollapse.CarouselSetting,
  getContent: getImageCarouselSetting,
  title: 'Carousel Setting',
  getErrorDisplay: getImageCollapseValidationMsgDisplay,
  onImageErrorChange,
  validation: (x, validationProps) => {
    //const { isPrimary } = validationProps || {};
    const { breakpoint } = validationProps || {};
    return validateCarouselSetting(x, { breakpoint });
  },
  headerProps: {
    dotsFunction: [
      // {
      //   onClick: () => {
      //     const dD = generateFooterStyle();
      //     store.dispatch(onFooterStyleChange(dD));
      //   },
      //   key: 'Reset',
      //   body: 'Reset',
      //   isDangerous: true,
      // },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
});
